import { InsuranceType } from "@comparaonline/cicl-funnel-schema";
import { Offer } from "@comparaonline/offers-models";
import { isInsuranceByKm } from "../../../models/product";

export const getInsuranceTypeByOffer = (offer: Offer): InsuranceType =>
  offer && isInsuranceByKm(offer.product) ? InsuranceType.ByKm : InsuranceType.Fixed;
